import { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

const funciones = [
  "Gestión avanzada de tareas",
  "Análisis de rentabilidad en tiempo real",
  "Interfaz intuitiva y personalizable",
  "Colaboración en equipo con notificaciones",
  "Reportes detallados de productividad"
];

const Josemite = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      {/* 🔹 Imagen de fondo */}
      <div className="fondo">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo de Josemite" 
          aria-hidden="true"
        />
        <div className="fondo-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo">Josemite: Control de Proyectos y Tareas</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src="/images/josemitesolucion.jpg"
          alt="josemite 1"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Josemite es una herramienta poderosa para la gestión de proyectos y tareas. Permite organizar y visualizar
            de forma eficiente todas las tareas de tu empresa con una interfaz similar a una hoja de cálculo.
          </p>
          <p>
            Además, ofrece un análisis detallado de rentabilidad por cliente, tipo de tarea o empleado, ayudando a tomar decisiones
            informadas basadas en datos en tiempo real.
          </p>
          <p>¡Descubre cómo Josemite puede optimizar la gestión de tus proyectos y tareas!</p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>Funciones Destacadas</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✓ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/josemitecarrusel${num}.png`}
                alt={`Josemite ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/josemitecarrusel${num}.png`}
              alt={`Josemite ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Josemite;
